import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { SlopeCalcVM, ISlopeCalcProps } from './SlopeCalcVM';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import stores from 'cd-eft/models/Stores';

const SlopeCalcComponent = (props: ISlopeCalcProps) => {
  const vm = useRef(new SlopeCalcVM(props)).current;

  useEffect(() => {
    // When the user clicks anywhere outside of the modal, close it
    const modal: any = document.getElementById('slopeCalcModal');
    window.onclick = function (event: any) {
      if (event.target === modal) {
        props.close();
      }
    };
  }, []);

  useEffect(() => {
    vm.getDrainageArea();
  }, [stores.AppStore.efh2Store.basicDataForm.drainageArea]);

  return (
    <div>
      <Modal isOpen={!props.hidden} toggle={props.close}>
        <ModalHeader toggle={props.close}>Slope Calculator</ModalHeader>
        <ModalBody>
          <form className="usa-form" onSubmit={vm.sendToBasicData}>
            <fieldset className="usa-fieldset">
              <label className="usa-label" htmlFor="contourLength">
                Length of Contours
              </label>

              <input
                className={'usa-input' + vm.errorClass('contourLength')}
                id="contourLength"
                aria-required="true"
                name="contourLength"
                type="number"
                value={vm.slopeCalcInput.contourLength}
                onChange={vm.handleInputChange}
              />
              <span className="usa-error-message" id="client--message" role="alert">
                {vm.formValidation.formErrors.contourLength}
              </span>
              <span>feet</span>

              <label className="usa-label" htmlFor="contourInterval">
                Contour Interval
              </label>

              <input
                className={'usa-input' + vm.errorClass('contourInterval')}
                id="contourInterval"
                aria-required="true"
                name="contourInterval"
                type="number"
                value={vm.slopeCalcInput.contourInterval}
                onChange={vm.handleInputChange}
              />
              <span className="usa-error-message" id="client--message" role="alert">
                {vm.formValidation.formErrors.contourInterval}
              </span>
              <span>feet</span>

              <label className="usa-label" htmlFor="drainArea">
                Drainage Area
              </label>
              <input
                className={'usa-input' + vm.errorClass('drainArea')}
                id="drainArea"
                aria-required="true"
                name="drainArea"
                type="number"
                value={vm.slopeCalcInput.drainArea}
                onChange={vm.handleInputChange}
              />
              <span className="usa-error-message" id="client--message" role="alert">
                {vm.formValidation.formErrors.drainArea}
              </span>
              <span>acres</span>
              <div className="margin-top-1">
                <strong>
                  Slope:
                  <span hidden={!vm.formValidation.formValid}>{!isNaN(vm.slope) ? ` ${vm.slope} %` : '  0 %'}</span>
                </strong>
              </div>
              <div>
                <input
                  disabled={!vm.formValidation.formValid}
                  className="usa-button"
                  type="submit"
                  value="Send to Form"
                />
              </div>
            </fieldset>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export const SlopeCalc = observer(SlopeCalcComponent);
